import { createRouter, createWebHistory } from 'vue-router'
import PraView from '../components/practise/PraView.vue'

const routes = [
  {
    path: '/',
    name: 'PraView',
    component: PraView
  },
   {
    path: '/login',
    name: 'LoginView',
    component: () => import('@/components/login/LoginView.vue')  // @代表src文件夹
  },
  {
    path: '/register',
    name: 'RegisterView',
    component: () => import('@/components/login/RegisterView.vue')  // @代表src文件夹
  },
  {
    path: '/about_yixi',
    name: 'AboutYixi',
    component: () => import('@/components/login/AboutYixi.vue')  // @代表src文件夹
  },
  {
    path: '/setpassword',
    name: 'SetPassword',
    component: () => import('@/components/login/SetPassword.vue')  // @代表src文件夹
  },
  {
    path: '/addtelephone',
    name: 'AddTelephone',
    component: () => import('@/components/login/AddTelephone.vue')  // @代表src文件夹
  },
  {
    path: '/fileorder',
    name: 'FileOrder',
    component: () => import('@/components/FileOrder.vue')  // @代表src文件夹
  },
  {
    path:"/practise/question",
    name:"StartQuestion",
    component:() => import("../components/practise/StartQuestion.vue")
  },
  {
    path:"/practise/report",
    name:"MyReport",
    component:() => import("../components/practise/MyReport.vue")
  },
  {
    path:"/practise/set",
    name:"SetPraNum",
    component:() => import("../components/practise/SetPraNum.vue")
  },
  {
    path:"/practise/expiration",
    name:"ExpirationNumber",
    component:() => import("../components/practise/ExpirationNumber.vue")
  },
  {
    path:"/practise/record",
    name:"MyRecord",
    component:() => import("../components/practise/MyRecord.vue")
  },
  {
    path:"/practise/emergency",
    name:"EmergencyTask",
    component:() => import("../components/practise/EmergencyTask.vue")
  },
  {
    path:"/practise/em_question",
    name:"StartEmergency",
    component:() => import("../components/practise/StartEmergency.vue")
  },
  {
    path: '/practise/reset',  //更多功能/重置任务
    name: 'ResetTask',
    component: () => import(/* webpackChunkName: "about" */ '../components/practise/ResetTask.vue'),
  },


  




  



  {
    path: '/question',
    name: 'QuestionView',
    component: () => import('@/components/question/QuestionView.vue')  // @代表tic文件夹
  },
  {
    path: '/question/new_firstfile',
    name: 'NewFirstFile',
    component: () => import('@/components/question/NewFirstFile.vue')  // @代表tic文件夹
  },
  {
    path: '/question/new_question',
    name: 'NewQuestion',
    component: () => import('@/components/question/NewQuestion.vue')  // @代表tic文件夹
  },
  {
    path: '/question/assort',
    name: 'QuestionAssort',
    component: () => import('@/components/question/QuestionAssort.vue')  // @代表tic文件夹
  },
  {
    path: '/question/secondfile',
    name: 'SecondFile',
    component: () => import('@/components/question/SecondFile.vue')  // @代表tic文件夹
  },
  {
    path: '/question/search',
    name: 'SearchQuestion',
    component: () => import('@/components/question/SearchQuestion.vue')  // @代表tic文件夹
  },
  {
    path: '/question/que_tag',  //更多功能/提问标签
    name: 'QuestionTag',
    component: () => import(/* webpackChunkName: "about" */ '../components/question/QuestionTag.vue'),
  },
  







  {
    path: '/test',
    name: 'TestView',
    component: () => import('@/components/test/TestView.vue'),  // @代表tic文件夹
  },
  {
    path: '/test/mulu',
    name: 'TestMulu',
    component: () => import('@/components/test/TestMulu.vue'),  // @代表tic文件夹
  },
  {
    path: '/test/english',
    name: 'TestEnglish',
    component: () => import('@/components/test/TestEnglish.vue'),  // @代表tic文件夹
  },
  {
    path: '/test/check',
    name: 'TestCheck',
    component: () => import('@/components/test/TestCheck.vue'),  // @代表tic文件夹
  },
  {
    path: '/test/report',
    name: 'TestReport',
    component: () => import('@/components/test/TestReport.vue'),  // @代表tic文件夹
  },









  {
    path: '/my',
    name: 'my',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyView.vue'),
  },
  {
    path: '/my/account', //账号中心
    name: 'MyAccount',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyAccount.vue'),
  },
  {
    path: '/my/account/number',  //账号中心/账号
    name: 'AccountNumber',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/AccountNumber.vue'),
  },
  {
    path: '/my/account/modify',  //账号中心/账号/修改账户
    name: 'AccountModify',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/AccountModify.vue'),
  },
  {
    path: '/my/account/delete',  //账号中心/账号/注销账户
    name: 'AccountDelete',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/AccountDelete.vue'),
  },
  {
    path: '/my/account/phone',  //账号中心/手机号
    name: 'PhoneNumber',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/PhoneNumber.vue'),
  },
  {
    path: '/my/account/password',  //账号中心/修改密码
    name: 'AccountPassword',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/AccountPassword.vue'),
  },
  {
    path: '/my/account/member',  //账号中心/会员
    name: 'MemberCenter',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MemberCenter.vue'),
  },
  {
    path: '/my/account/countcentre',  //更多功能/计算练习
    name: 'CountPractice',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/CountPractice.vue'),
  },
  {
    path: '/my/orders',  
    name: 'MyOrders',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyOrders.vue'),
  },
  {
    path: '/my/manual',  //使用手册
    name: 'UserManual',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/UserManual.vue'),
  },
  {
    path: '/my/manual/detail',  //使用手册/使用明细
    name: 'ManualDetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/ManualDetail.vue'),
  },
  {
    path: '/my/invite',  //推荐有礼
    name: 'MyInvite',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyInvite.vue'),
  },
  {
    path: '/my/invitationRecord',  //推荐有礼
    name: 'MyInvitationRecord',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyInvitationRecord.vue'),
  },
  {
    path: '/my/service',  //联系客服
    name: 'ContactService',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/ContactService.vue'),
  },
  {
    path: '/my/user_message',  //用户反馈
    name: 'UserMessage',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/UserMessage.vue'),
  },
  {
    path: '/my/user_message/message',  //我的留言
    name: 'MyMessage',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/MyMessage.vue'),
  },
  {
    path: '/my/account/member/manage_recharge',  //我的留言
    name: 'ManageRechargeCode',
    component: () => import(/* webpackChunkName: "about" */ '../components/my/ManageRechargeCode.vue'),
  },





  {
    path: '/stock',  //我的留言
    name: 'StockView',
    component: () => import(/* webpackChunkName: "about" */ '../components/stock/StockView.vue'),
  },
  
  
  
  








]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
